<template>
  <v-container fluid>
    <v-row>
      <v-col sm="12" md="4" cols="12">
        <v-card>
          <v-card-title><h3>Phone Status</h3></v-card-title>
          <v-card-text>
            <v-alert :type="status">{{ statusText }}</v-alert>
            <v-btn
                @click="online"
                :disabled="disableOnlineButton"
                color="success"
            >Online
            </v-btn>
            <v-btn
                @click="offline"
                :disabled="disableOfflineButton"
                color="error"
                class="float-right"
            >Offline
            </v-btn>
          </v-card-text>
        </v-card>
        <br/>
        <v-card>
          <v-card-title><h3>Phone Messages</h3></v-card-title>
          <v-card-text>
            <v-card v-for="(item, counter) in messages" :key="counter" style="margin: 5px;" outlined>
              <v-card-text>
                <v-btn @click="get_recording(item.sid)" style="float: right;" color="orange" x-small>Fetch Recording
                </v-btn>
                <b>From:</b>
                <span style="clear: none;" v-if="item.name">{{ item.name }} (</span>
                <span style="clear: none;" v-if="item.from">{{ item.from_formatted }}</span>
                <span style="clear: none;" v-if="item.name">)</span>
                <span>&nbsp;</span>
                <b>Date:</b> {{ item.created | date }}<br/>
                <span>{{ item.text }}</span>
                <span><br/><b>Recording ID:</b> {{ item.sid }}</span>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-btn
                @click="get_messages"
                :disabled="disableGetMessagesButton"
                color="success"
            >Get Messages
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col sm="12" md="8" cols="12">
        <v-card>
          <v-card-title><h3>Call Status</h3></v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                    v-model="phoneNumber"
                    label="Phone Number"
                    hint="Include + and country code"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                    v-model="callStartText"
                    label="Call Start"
                    append-icon="mdi-content-copy"
                    @click:append="copyText(callStart)"
                    readonly
                    dense
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                    v-model="callStopText"
                    label="Call End"
                    append-icon="mdi-content-copy"
                    @click:append="copyText(callStop)"
                    readonly
                    dense
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                    v-model="callDuration"
                    label="Duration (Min)"
                    append-icon="mdi-content-copy"
                    @click:append="copyText(callDuration)"
                    readonly
                    dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                    @click="answer"
                    :disabled="disableAnswerButton"
                    color="primary"
                    class="ma-1"
                >Answer
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                    @click="connect"
                    :disabled="disableCallButton"
                    color="primary"
                    class="ma-1"
                >Call
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                    @click="hangup"
                    :disabled="disableHangupButton"
                    color="error"
                    class="ma-1 float-right"
                >Hangup
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import {mapState} from "vuex";
import {Device} from "@twilio/voice-sdk"

export default {
  name: "Dashboard",
  computed: {
    ...mapState(['user', 'twilio', 'messages']),
    callStartText() {
      if (this.callStart) {
        return this.callStart.toLocaleString('en-US'  )
      }
      return null
    },
    callStopText() {
      if (this.callStop) {
        return this.callStop.toLocaleString('en-US'  )
      }
      return null
    },
    callDuration() {
      if (this.callStart && this.callStop) {
        return Math.round(((this.callStop - this.callStart) / 1000) / 60)
      }
      return null
    },
  },
  data() {
    return {
      // Status
      status: 'error',
      statusText: 'Offline',
      // Button states
      disableGetMessagesButton: true,
      disableAnswerButton: true,
      disableCallButton: true,
      disableHangupButton: true,
      disableOnlineButton: false,
      disableOfflineButton: true,
      // Device states
      device: null,
      call: null,
      callIncoming: false,
      callStart: null,
      callStop: null,
      // Phone
      phoneNumber: null,
    }
  },
  watch: {
    device: function (device) {
      console.log('Device:', device !== null)
      if (device !== null) {
        this.disableGetMessagesButton = false
        this.disableOnlineButton = true
        this.disableOfflineButton = false
        this.disableCallButton = false
        this.status = 'success'
        this.statusText = 'Online / Ready'
      } else {
        this.disableOnlineButton = false
        this.disableOfflineButton = true
        this.disableCallButton = true
        this.disableGetMessagesButton = true
        this.status = 'error'
        this.statusText = 'Offline'
      }
    },
    call: function (call) {
      console.log('Call:', call)
      if (call !== null) {
        if (!this.callIncoming) {
          this.disableAnswerButton = true
        }
        this.callIncoming = false
        call.on('accept', () => {
          console.log('- Accepted')
          this.disableHangupButton = false
          this.disableCallButton = true
          this.callStart = new Date()
          this.callStop = null
        })
        call.on('disconnect', () => {
          console.log('- Disconnected')
          this.disableHangupButton = true
          this.disableAnswerButton = true
          this.disableCallButton = false
          this.callStop = new Date()
          this.call = null
        })
        call.on('cancel', () => {
          console.log('- Canceled')
          this.disableHangupButton = true
          this.disableAnswerButton = true
          this.disableCallButton = false
          this.callStop = new Date()
          this.call = null
        })
      }
    },
  },
  methods: {
    copyText(value) {
      navigator.clipboard.writeText(value)
    },
    answer() {
      if (this.call) {
        this.call.accept()
      }
    },
    connect() {
      if (!this.device) {
        this.$toasted.error('Device not ready, go online first.').goAway(2000)
        return
      }
      // Twilio Voice SDK v2 expects params under a params key
      this.device.connect({
        params: {
          phoneNumber: this.phoneNumber
        }
      }).then((call) => {
        this.call = call
      })
    },
    hangup() {
      if (this.device && typeof this.device.disconnectAll === 'function') {
        this.device.disconnectAll()
      }
      if (this.call && typeof this.call.disconnect === 'function') {
        this.call.disconnect()
      }
      this.call = null
    },
    offline() {
      if (this.device && typeof this.device.unregister === 'function') {
        this.device.unregister()
      }
      if (this.device && typeof this.device.destroy === 'function') {
        this.device.destroy()
      }
      this.device = null
      this.call = null
    },
    get_messages() {
      this.$store.dispatch('getMessages')
    },
    get_recording(sid) {
      this.$store.dispatch('getRecording', sid)
    },
    online() {
      const toastConfig = {
        position: "bottom-center",
        theme: "outline",
      }
      // Get the Twilio Token
      this.$store.dispatch('getTwilio').then(() => {
        // We have the token, create the Device
        this.device = new Device(this.twilio.token, {
          // codecPreferences: ['opus', 'pcmu'],
          fakeLocalDTMF: true,
          closeProtection: true,
          debug: false,
        })
        // Report that we are registering
        this.device.on('registering', async () => {
          this.$toasted.info(
              'Registering ...',
              toastConfig
          ).goAway(2000)
        })
        // Report that we are online and set the status and button availability
        this.device.on('registered', async () => {
          this.$toasted.info(
              'Device registered, ready to make and accept calls',
              toastConfig
          ).goAway(2000)
        })
        // Report that we are offline and set the status and button availability
        this.device.on('unregistered', async () => {
          this.$toasted.info(
              'Device unregistered. You are now offline and can no longer make or receive calls.',
              toastConfig
          ).goAway(4000)
        })
        // Incoming call
        this.device.on('incoming', async (call) => {
          console.log('Incoming call from:', call)
          console.log('Current call:', this.call)
          console.log('Call check:', this.call === null)
          if (this.call === null) {
            console.log('Enabling the answer button')
            this.disableHangupButton = true
            this.disableAnswerButton = false
            console.log('Setting the call to the incoming call')
            this.callIncoming = true
            this.call = call
          }
        })
        // Register to start receiving incoming calls
        if (this.device && typeof this.device.register === 'function') {
          this.device.register()
        }
      })
    }
  },
  created() {
    this.$store.dispatch('getUser')
  }
}
</script>

<style scoped>

</style>
